import type { ReactNode } from 'react'

export type ChipVariant = 'default' | 'manager' | 'result' | 'fail' | 'transport'

const VARIANT_CLASS: Readonly<Record<ChipVariant, string>> = {
  default: '',
  manager: 'chip-mgr',
  result: 'chip-result',
  fail: 'chip-fail',
  transport: 'chip-transport',
}

export function Chip({
  children,
  variant = 'default',
}: {
  readonly children: ReactNode
  readonly variant?: ChipVariant
}): JSX.Element {
  return <span className={`chip ${VARIANT_CLASS[variant]}`.trim()}>{children}</span>
}
